import React, { useState } from 'react'
import { Form, usePage } from '@inertiajs/react'
import Layout from '../../components/Layout'

export default function EditProfile({ user, minimum_password_length }) {
  const { errors } = usePage().props
  const [processing, setProcessing] = useState(false)

  const userErrors = errors?.user || errors || {}

  function handleDeleteSubmit(e) {
    if (!confirm('Essa acao nao pode ser revertida. Voce tem certeza que deseja cancelar sua conta?')) {
      e.preventDefault()
    }
  }

  return (
    <Layout>
      <div className="max-w-2xl mx-auto py-8">
        <h1 className="text-2xl font-bold text-brand-dark mb-6 font-heading">Editar Perfil</h1>

        <div className="bg-white border border-gray-200 rounded-lg p-6">
          {(user?.nome || user?.sobrenome) && (
            <div className="mb-6 pb-4 border-b border-gray-200">
              <p className="text-sm text-gray-500">Conta de</p>
              <p className="text-base font-medium text-gray-900">
                {[user?.nome, user?.sobrenome].filter(Boolean).join(' ')}
              </p>
            </div>
          )}

          <Form
            action="/users"
            method="put"
            options={{ forceFormData: true }}
            onStart={() => setProcessing(true)}
            onFinish={() => setProcessing(false)}
          >
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="user[email]"
                defaultValue={user?.email || ''}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light"
                autoComplete="email"
              />
              {userErrors.email && (
                <div className="mt-1 text-red-600 text-sm">{userErrors.email}</div>
              )}
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                Nova Senha
                <span className="text-gray-500 font-normal"> (deixe em branco se nao quiser alterar)</span>
              </label>
              <input
                type="password"
                id="password"
                name="user[password]"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light"
                autoComplete="new-password"
              />
              {minimum_password_length && (
                <p className="mt-1 text-gray-500 text-sm">Minimo de {minimum_password_length} caracteres</p>
              )}
              {userErrors.password && (
                <div className="mt-1 text-red-600 text-sm">{userErrors.password}</div>
              )}
            </div>

            <div className="mb-4">
              <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mb-1">
                Confirmar Nova Senha
              </label>
              <input
                type="password"
                id="password_confirmation"
                name="user[password_confirmation]"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light"
                autoComplete="new-password"
              />
              {userErrors.password_confirmation && (
                <div className="mt-1 text-red-600 text-sm">{userErrors.password_confirmation}</div>
              )}
            </div>

            <div className="mb-6">
              <label htmlFor="current_password" className="block text-sm font-medium text-gray-700 mb-1">
                Senha Atual
                <span className="text-gray-500 font-normal"> (necessaria para confirmar alteracoes)</span>
              </label>
              <input
                type="password"
                id="current_password"
                name="user[current_password]"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light"
                autoComplete="current-password"
              />
              {userErrors.current_password && (
                <div className="mt-1 text-red-600 text-sm">{userErrors.current_password}</div>
              )}
            </div>

            <button
              type="submit"
              disabled={processing}
              className="w-full py-2 bg-brand-dark hover:bg-brand-light text-white font-medium rounded-md transition-colors disabled:opacity-50"
            >
              {processing ? 'Atualizando...' : 'Atualizar'}
            </button>
          </Form>
        </div>

        <div className="mt-8 bg-red-50 border border-red-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-red-800 mb-2">Cancelar minha conta</h3>
          <p className="text-red-600 text-sm mb-4">
            Nao esta satisfeito? Voce pode cancelar sua conta permanentemente.
          </p>
          <Form
            action="/users"
            method="delete"
            onSubmit={handleDeleteSubmit}
          >
            <button
              type="submit"
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors"
            >
              Cancelar minha conta
            </button>
          </Form>
        </div>
      </div>
    </Layout>
  )
}
